import { render, staticRenderFns } from "./PagosMultasSelectNuevo.vue?vue&type=template&id=120a8ffa&scoped=true&"
import script from "./PagosMultasSelectNuevo.vue?vue&type=script&lang=js&"
export * from "./PagosMultasSelectNuevo.vue?vue&type=script&lang=js&"
import style0 from "./PagosMultasSelectNuevo.vue?vue&type=style&index=0&id=120a8ffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a8ffa",
  null
  
)

export default component.exports